export default __webpack_public_path__ + "static/media/project1.8c027424.png";